import { css, keyframes, styled } from 'next-yak';
import type { ElementType } from 'react';

import { createPolymorphicElement } from '@xing-com/polymorphic-element';
import {
  xdlColorSkeletonPrimary,
  xdlColorSkeletonPrimaryAnimation,
  motionTimeXXL,
  motionEasingStandard,
} from '@xing-com/tokens';

type SkeletonSuperEllipseTProps = {
  $size?: string;
};

// *** Animations ***
const animation = keyframes`
  0% {
    fill: ${xdlColorSkeletonPrimaryAnimation};
  }
  100% {
    fill: ${xdlColorSkeletonPrimary};
  }
`;

const SkeletonSuperEllipseElement = createPolymorphicElement<
  'svg',
  ElementType,
  SVGElement
>('svg');

export const SkeletonSuperEllipse = styled(
  SkeletonSuperEllipseElement
)<SkeletonSuperEllipseTProps>`
  animation-direction: alternate;
  animation-duration: ${motionTimeXXL};
  animation-iteration-count: infinite;
  animation-name: ${animation};
  animation-timing-function: ${motionEasingStandard};
  fill: ${xdlColorSkeletonPrimary};

  ${({ $size }) =>
    $size &&
    css`
      height: ${() => $size};
      width: ${() => $size};
    `};
`;
